import { useState, useEffect } from 'react';
import { useWeb3React } from '@web3-react/core';
import LendBorrowHOC from 'hoc/LendBorrowHOC';
import SyncCard from 'components/UI/SyncCard';
import OffersTable from 'parts/Assets/OffersTable';
import { getLenderOffersByAddress } from 'services/nftfi';

function OffersPage({}) {
  const context = useWeb3React();
  const { account } = context;
  const [offers, setOffers] = useState();

  const fetchOffers = async () => {
    try {
      const result = await getLenderOffersByAddress(account); //'0x924942D4006FE26c9beAaDBAe1C35417EF277816'
      setOffers(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (account) {
      fetchOffers();
    }
  }, [account]);

  return (
    <SyncCard>
      {offers && (
        <OffersTable offers={offers} setOffers={setOffers} title='OFFERS MADE' address={account} />
      )}
    </SyncCard>
  );
}

export default LendBorrowHOC(OffersPage, true);
